import { removeFromQuery } from '@ringcentral/rwc-utils/src/urls/remove-from-query';
import { AuthData } from '@ringcentral/sdk/lib/platform/Auth';
import { readLocallyStored, writeLocallyStored } from '@ringcentral/rwc-utils/src/local-storage';
import { extractFromQueryString } from '@ringcentral/rwc-utils/src/url';
import { uuidv4 } from '@rwc/utils/misc';

const deviceId = extractFromQueryString('deviceId', null);
if (deviceId) {
    removeFromQuery('deviceId', false);
}

let guestEndpointId = readLocallyStored<string | null>('guestEndpointId', null);
let storedToken = readLocallyStored<AuthData | null>('rc-platform', null);
let discardedStoredOwnerSession = false;

if (deviceId && (!guestEndpointId || guestEndpointId !== deviceId)) {
    // deviceId must have precedence over guestPointId and override stored token
    guestEndpointId = deviceId;
    writeLocallyStored('guestEndpointId', guestEndpointId, true);
    storedToken = null;
    writeLocallyStored('rc-platform', null, true);
} else if (!guestEndpointId) {
    guestEndpointId = uuidv4();
    writeLocallyStored('guestEndpointId', guestEndpointId, true);
}

const now = +new Date();
if (
    storedToken &&
    ((!storedToken.refresh_token && (storedToken.expire_time || 0) - 100000 < now) ||
        (storedToken.refresh_token && (storedToken.refresh_token_expire_time || 0) < now))
) {
    if (storedToken.owner_id) {
        discardedStoredOwnerSession = true;
    }

    storedToken = null;
    writeLocallyStored('rc-platform', storedToken, true);
    // TODO probably we should remember location, user want to open (ex: recording page)
    // window.location.replace('/');
}

const wrapToken = (token: AuthData): AuthData => ({
    ...token,
    expire_time: Date.now() + parseInt(token['expires_in'] || '3600') * 1000, // eslint-disable-line camelcase
    refresh_token_expire_time:
        Date.now() + parseInt(token['refresh_token_expires_in'] || '604800') * 1000, // eslint-disable-line camelcase
});

export const getGuestEndpointId = () => guestEndpointId;
export const getStoredToken = () => storedToken;
export const consumeDiscardedStoredOwnerSession = () => {
    const discarded = discardedStoredOwnerSession;
    discardedStoredOwnerSession = false;
    return discarded;
};

export const loginAsGuest = (
    sdk,
    {
        beforeRequest,
        onRequestFailed,
        onRequestSuccess,
    }: {
        beforeRequest?: () => void;
        onRequestFailed?: (statusCode: number) => void;
        onRequestSuccess?: (authData: AuthData) => void;
    } = {}
): Promise<AuthData> => {
    beforeRequest && beforeRequest();
    return sdk()
        .platform()
        .login({
            resource: location.href,
            resource_type: 'RCV', // eslint-disable-line camelcase
            endpoint_id: guestEndpointId, // eslint-disable-line camelcase
        })
        .then(response => response.json())
        .then(wrapToken)
        .catch(e => {
            const statusCode = e.response?.status || 500;
            onRequestFailed && onRequestFailed(statusCode);
            throw statusCode;
        })
        .then(authInfo => {
            onRequestSuccess && onRequestSuccess(authInfo);
            return authInfo;
        });
};
